import "./abilityCart.css";

export default function AbilityCart({ item }) {
  return (
    <div className="abilityView p-1 centerXY">
      <div className="">{item}</div>
    </div>
  );
}
